import { BookmarkFolder, isBookmarkFolder } from './model'
import { updateBookmarkState } from './storage'

export function exportBookmarks(root: BookmarkFolder) {
  const blob = new Blob([JSON.stringify(root, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = 'hscMap-Bookmark.json'
  anchor.click()
  URL.revokeObjectURL(url)
}

export async function importBookmarks() {
  const file = await chooseJsonFile()
  if (!file) {
    return
  }
  try {
    const parsed = JSON.parse(await file.text())
    if (!isBookmarkFolder(parsed)) {
      throw new Error('The root must be a bookmark folder')
    }
    const name = prompt('New folder name ?', file.name)
    if (!name) {
      return
    }
    parsed.name = name
    updateBookmarkState(state => {
      state.root.children.push(parsed)
    })
  } catch (error) {
    alert(`Import error: ${error}`)
  }
}

function chooseJsonFile() {
  return new Promise<File | null>(resolve => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.json,application/json'
    input.addEventListener('change', () => resolve(input.files?.item(0) ?? null), { once: true })
    input.addEventListener('cancel', () => resolve(null), { once: true })
    input.click()
  })
}
